export enum OperativeReportName {
  LocomotiveDamage = 'damage',
  Delay = 'delay',
  ActivityStart = 'activity-start', // WILP-13418: matches BE's seeded `name`
  ActivityEnd = 'activity-end', // WILP-13419: matches BE's seeded `name`
}

export enum OperativeReportPriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export enum OperativeReportStatus {
  Open = 'open',
  Done = 'done',
}
